import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const heroHeight = window.innerHeight * 0.6;
      setVisible(scrollY > heroHeight);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = () => {
    const el = document.getElementById('final-cta');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <AnimatePresence data-id="element-96">
      {visible && <motion.div initial={{
      y: -80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -80,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed top-0 left-0 right-0 z-50 bg-brown-900/80 backdrop-blur-md shadow-lg border-b border-brown-800/50" data-id="element-97">
          <div className="max-w-4xl mx-auto px-4 py-2.5 flex items-center justify-center" data-id="element-98">
            <motion.button onClick={scrollToSection} animate={{
          boxShadow: ['0 0 0 0 rgba(194, 107, 67, 0)', '0 0 0 6px rgba(194, 107, 67, 0.15)', '0 0 0 0 rgba(194, 107, 67, 0)']
        }} transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="px-7 py-2.5 text-sm font-bold text-white bg-terracotta-500 rounded-full hover:bg-terracotta-600 transition-colors duration-300" data-id="element-99">
              Protect My Savings Now
            </motion.button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}